import React from 'react';
import { ContactForm } from '../components/ContactForm';
import { AiOutlineMail, AiOutlineHome, AiOutlinePhone } from 'react-icons/ai'

export default function Contact() {
    const contactCards = [
        {
            icon: <AiOutlineHome size={"1.65em"} />,
            label: "Meet Us:",
            content: "2405 Lucknow Drive, Mississauga, On, L5S 1H9",
        },
        {
            icon: <AiOutlinePhone size={"1.65em"} />,
            label: "Call Us:",
            content: (
                <a href="tel:905-564-2033" className='text-red-600 transition hover:text-red-700'>
                    905-564-2033
                </a>
            ),
        },
        {
            icon: <AiOutlineMail size={"1.65em"} />,
            label: "Mail Us:",
            content: (
                <a href="mailto:inquiries@cedonia.ca" className='text-red-600 transition hover:text-red-700'>
                    inquiries@cedonia.ca
                </a>
            ),
        },
    ];

    return (
        <div className='bg-zinc-50 text-zinc-900'>
            <section className='relative overflow-hidden bg-white'>
                <div className='absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-red-500/40 to-transparent' />
                <div className='mx-auto max-w-7xl px-6 py-16 text-center sm:py-20 lg:px-8'>
                    <p className='text-sm font-semibold uppercase tracking-[0.24em] text-red-600'>Cedonia</p>
                    <h1 className='mt-4 text-5xl font-extrabold tracking-tight text-zinc-950 sm:text-7xl'>
                        Contact Us
                    </h1>
                    <p className='mx-auto mt-5 max-w-2xl text-lg leading-8 text-zinc-600'>
                        Speak with our team about custom machining, project requirements, and how Cedonia can support your next build.
                    </p>
                    <div className='mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row'>
                        <a
                            href='tel:905-564-2033'
                            className='inline-flex w-full items-center justify-center rounded-md bg-red-600 px-6 py-3 text-base font-semibold text-white shadow-sm shadow-red-900/10 transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-lg hover:shadow-red-900/15 sm:w-auto'
                        >
                            Call Us
                        </a>
                        <a
                            href='mailto:inquiries@cedonia.ca'
                            className='inline-flex w-full items-center justify-center rounded-md border border-zinc-300 bg-white px-6 py-3 text-base font-semibold text-zinc-900 transition duration-200 hover:-translate-y-0.5 hover:border-red-200 hover:text-red-600 hover:shadow-lg hover:shadow-zinc-900/5 sm:w-auto'
                        >
                            Email Us Now
                        </a>
                    </div>
                </div>
            </section>

            <section className='bg-zinc-50 px-4 py-12 sm:px-6 lg:px-8 lg:py-16'>
                <div className='mx-auto grid max-w-7xl gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(380px,0.78fr)] lg:items-stretch'>
                    <div className='overflow-hidden rounded-lg border border-zinc-200 bg-white shadow-xl shadow-zinc-900/5'>
                        <iframe
                            title="Cedonia location map"
                            width="100%"
                            height="100%"
                            className='min-h-[360px] w-full grayscale-[20%] transition duration-300 hover:grayscale-0 lg:min-h-[620px]'
                            frameBorder="0"
                            scrolling="no"
                            marginHeight="0"
                            marginWidth="0"
                            id="gmap_canvas"
                            src="https://maps.google.com/maps?width=967&amp;height=551&amp;hl=en&amp;q=2405%20Lucknow%20Dr%20Mississauga+(Cedonia)&amp;t=&amp;z=18&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                        ></iframe>
                        <a href='https://maps-generator.com/' className='sr-only'>Map generator</a>
                    </div>

                    <div className='flex flex-col justify-between rounded-lg border border-zinc-200 bg-white p-6 shadow-xl shadow-zinc-900/5 sm:p-8 lg:p-10'>
                        <div>
                            <p className='text-sm font-semibold uppercase tracking-[0.22em] text-red-600'>Start a conversation</p>
                            <h2 className='mt-3 text-3xl font-extrabold tracking-tight text-zinc-950 sm:text-4xl'>
                                Email Us Now
                            </h2>
                            <p className='mt-4 text-base leading-7 text-zinc-600'>
                                Send a message with your project details and the Cedonia team will follow up in the next few business days.
                            </p>
                        </div>
                        <div className='mt-8'>
                            <ContactForm></ContactForm>
                        </div>
                    </div>
                </div>
            </section>

            <section className='bg-white px-4 py-12 sm:px-6 lg:px-8 lg:py-16'>
                <div className='mx-auto max-w-7xl'>
                    <div className='grid gap-4 md:grid-cols-3'>
                        {contactCards.map((item) => (
                            <div className='group rounded-lg border border-zinc-200 bg-white p-6 shadow-sm transition duration-200 hover:-translate-y-1 hover:border-red-100 hover:shadow-xl hover:shadow-zinc-900/10' key={item.label}>
                                <div className='flex h-12 w-12 items-center justify-center rounded-md bg-zinc-950 text-white transition duration-200 group-hover:bg-red-600'>
                                    {item.icon}
                                </div>
                                <p className='mt-5 text-sm font-semibold uppercase tracking-[0.18em] text-zinc-500'>
                                    {item.label}
                                </p>
                                <div className='mt-2 text-lg leading-7 text-zinc-950'>
                                    {item.content}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div >
    )
}
